import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import DataApp from './DataApp';
import { BrowserRouter as Router } from 'react-router-dom'

ReactDOM.render(
  <Router>
    <DataApp />
  </Router>,
  document.getElementById('root')
);

